import { analytics } from "utils/constants/firebase";

export const useAnalytics = (screen) => {
  analytics().setCurrentScreen(window.location.pathname);
  analytics().logEvent(screen);
};
